module.exports = __webpack_public_path__ + "img/logo.b5aff73e.png";